import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-profile-edit',
    templateUrl: './breadcrumb.user.profile.edit.component.html'
})

export class BreadcrumbUserProfileEditComponent { }
